import {
    UseMutateAsyncFunction,
    UseMutateFunction,
} from '@tanstack/react-query';

import { BaseError } from '../../helpers/BaseError';

import {
    MessageContent,
    MessageContentUpdate,
    MessageContentUpdateResponse,
} from '../../models/message-content.model';

import useGetCurrentMessageContent from './useGetCurrentMessageContent';
import useGetMessageContentById from './useMessageContentQuery';
import useMessageContentUpdateMutation from './useMessageContentUpdateMutation';

type UseMessageContentGetAndUpdate = {
    mutate: UseMutateFunction<
        MessageContentUpdateResponse,
        BaseError,
        MessageContentUpdate
    >;
    mutateAsync: UseMutateAsyncFunction<
        MessageContentUpdateResponse,
        BaseError,
        MessageContentUpdate
    >;
    data?: MessageContent;
    isDataLoading: boolean;
    isUpdating: boolean;
    isDataError: boolean;
    isUpdatingError: boolean;
};

export default function useMessageContentGetAndUpdate(
    formulaId?: number,
    messageContentId?: string,
): UseMessageContentGetAndUpdate {
    const { currentMessageContentId, isLoading: isMessageContentIdLoading } =
        useGetCurrentMessageContent(formulaId);

    const messageContentIdToUse = messageContentId || currentMessageContentId;

    const {
        data: messageContent,
        isLoading,
        isError: isDataError,
    } = useGetMessageContentById(messageContentIdToUse!);

    const {
        mutate,
        mutateAsync,
        isPending,
        isError: isUpdatingError,
    } = useMessageContentUpdateMutation();

    return {
        mutate,
        mutateAsync,
        data: messageContent,
        isDataLoading: isLoading || isMessageContentIdLoading,
        isUpdating: isPending,
        isDataError: isDataError,
        isUpdatingError: isUpdatingError,
    };
}
